const customSwiper = {
	classes: {
		swiper: "custom-swiper",
	},
	is: (swiper, classname) => {
		return document.querySelector(swiper.el).classList.contains(classname);
	},
};
const sections = {
	video: "video-section",
};

function initNewSwiper(swiper_selector, thumbs_of_swiper = null) {
	/*
    swiper_selector -> to prevent conflicts it is better to use id
    the swipe settings could be assigned in html with data attributes to the swiper_selector
    if something is not set - it gets a default val
    feel free to bring more stuff :)

    thumbs_of_swiper -> when slider has thumbs: the function is called like initBangSwiper('thumbs-slider', 'main-slider')
      after the thumbs-slider is initialized, it will call automaticaly init of the main-slider
  */
	var swiper_element = document.querySelector(swiper_selector);
	var effect = swiper_element.dataset.effect ? swiper_element.dataset.effect : "slide";

	//speed and autoplayDelay can accept value 0
	var speed = typeof swiper_element.dataset.speed != "undefined" ? swiper_element.dataset.speed : 2500;

	/*set data-autoplay="false" to disable autoplay; any other value in ms like 1000 2000 will activate the autoplay*/
	var autoplayDelay = typeof swiper_element.dataset.autoplay != "undefined" ? swiper_element.dataset.autoplay : 1000;
	var autoplayMobile = typeof swiper_element.dataset.autoplayMobile != "undefined" ? swiper_element.dataset.autoplayMobile : 5000;

	var autoplayMobileSettings = false;

	if (autoplayMobile) {
		var autoplayMobileSettings = {
			delay: autoplayMobile,
			disableOnInteraction: false,
		};
	}

	var autoplaySubSettings = false;
	if (autoplayDelay) {
		var autoplaySubSettings = {
			delay: autoplayDelay,
			disableOnInteraction: false,
		};
	}

	var loop = swiper_element.dataset.loop ? true : false;

	var gridRows = swiper_element.dataset.gridRows ? swiper_element.dataset.gridRows : 1;

	var perViewMobile = swiper_element.dataset.perViewMobile ? parseFloat(swiper_element.dataset.perViewMobile) : 1;
	var perViewTablet = swiper_element.dataset.perViewTablet ? parseFloat(swiper_element.dataset.perViewTablet) : 1;
	var perViewTablet__big = swiper_element.dataset.perViewTabletBig ? parseFloat(swiper_element.dataset.perViewTabletBig) : false;
	var perViewDesktop = swiper_element.dataset.perViewDesktop ? parseFloat(swiper_element.dataset.perViewDesktop) : 1;

	var loopedSlides = swiper_element.dataset.perViewMobile ? parseFloat(swiper_element.dataset.perViewDesktop) : 0;

	var betweenMobile = swiper_element.dataset.betweenMobile ? parseInt(swiper_element.dataset.betweenMobile) : 15;
	var betweenTablet = swiper_element.dataset.betweenTablet ? parseInt(swiper_element.dataset.betweenTablet) : 15;
	var betweenDesktop = swiper_element.dataset.betweenDesktop ? parseInt(swiper_element.dataset.betweenDesktop) : 15;

	var initialSlideMobile = swiper_element.dataset.initialSlideMobile ? parseInt(swiper_element.dataset.initialSlideMobile) : 0;
	var initialSlideTablet = swiper_element.dataset.initialSlideTablet ? parseInt(swiper_element.dataset.initialSlideTablet) : 0;
	var initialSlideDesktop = swiper_element.dataset.initialSlideDesktop ? parseInt(swiper_element.dataset.initialSlideDesktop) : 0;

	var mobile_centered = swiper_element.dataset.mobileCentered ? swiper_element.dataset.mobileCentered : false;
	var tablet_centered = swiper_element.dataset.tabletCentered ? swiper_element.dataset.tabletCentered : false;
	var desktop_centered = swiper_element.dataset.desktopCentered ? true : false;

	var custom_pagination = swiper_element.dataset.customPagination ? swiper_element.dataset.customPagination : false;

  	var force_to_axis = swiper_element.dataset.forceToAxis ? swiper_element.dataset.forceToAxis: false;

	var mobile_disabled = swiper_element.dataset.mobileDisabled ? false : true;
	var tablet_disabled = swiper_element.dataset.tabletDisabled ? false : true;
	var desktop_disabled = swiper_element.dataset.desktopDisabled ? false : true;

	var slider_direction = swiper_element.dataset.sliderDirection ? swiper_element.dataset.sliderDirection : "horizontal";

	var slider_auto_height_desktop = swiper_element.dataset.autoHeightDesktop ? true : false;
	var slider_auto_height_tablet = swiper_element.dataset.autoHeightTablet ? true : false;
	var slider_auto_height_mobile = swiper_element.dataset.autoHeightMobile ? true : false;

	var freemode = swiper_element.dataset.freemode ? true : false;
	var navigationSubSettings = false;

  var autoplay_settings = false;
  if(swiper_element.dataset.autoplay && swiper_element.dataset.autoplay > 0){
  	autoplay_settings = {
    	delay: swiper_element.dataset.autoplay,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    }
  }


  var mousewheel_settings = false;
  if(force_to_axis) {
    mousewheel_settings = {
      forceToAxis: force_to_axis,
	  sensitivity: 0.7,
    }
  }

  	var slidesToLoop = perViewDesktop * 2;
	if( slidesToLoop < loopedSlides ) {
		slidesToLoop = loopedSlides;
	}

	let scrollbar = '';
	if (swiper_element.querySelector('.swiper-scrollbar') != null) {
		scrollbar = ".swiper-scrollbar"
	}

	var swiper_f = new Swiper(swiper_selector, {
		effect: effect,
		fadeEffect: { crossFade: true },
		slidesPerView: perViewMobile,
		spaceBetween: betweenMobile,
		grid: {
			rows: gridRows,
		},
		loop: loop,
		// loopedSlides: slidesToLoop,
		speed: speed,
		freeMode: {
			enabled: freemode,
			sticky: false,
		},
    	autoplay: autoplay_settings,
		noSwipingClass: "no-swiping",
		noSwiping: false,
		mousewheel: mousewheel_settings,
		observer: true,
		observerUpdate: true,
		observeSlideChildren: true,
		allowSlidePrev: true,
		allowSlideNext: true,
		scrollbar: {
			el: scrollbar,
			draggable: true,
		},
		pagination: {
			el: swiper_selector + " .swiper-pagination",
			clickable: true,
			renderBullet: function (index, className) {
				var custom_pagination_content = '<span class="' + className + '"></span>';

				if (custom_pagination) {
					custom_pagination_content =
						'<div class="swiper-bullet-with-image ' +
						className +
						'"><div class="swiper-bulet-image-holder"><img src="' +
						document.querySelector("#lookbook_img_" + index).dataset.image +
						'"></div></div>';
				}
				return custom_pagination_content;
			},
		},
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		breakpoints: {
			320: {
				spaceBetween: betweenMobile,
				centeredSlides: mobile_centered,
				initialSlide: initialSlideMobile,
				enabled: mobile_disabled,
				autoHeight: slider_auto_height_mobile,
				direction: "horizontal",
			},
			750: {
				/*750 and up to next*/
				slidesPerView: perViewTablet,
				spaceBetween: betweenTablet,
				autoplay: autoplayMobileSettings,
				centeredSlides: tablet_centered,
				initialSlide: initialSlideTablet,
				enabled: tablet_disabled,
				autoHeight: slider_auto_height_tablet,
				direction: "horizontal",
			},
			989: {
				/*990 and up to next*/
				slidesPerView: perViewTablet__big ? perViewTablet__big : perViewDesktop,
				spaceBetween: betweenDesktop,
				initialSlide: initialSlideDesktop,
				centeredSlides: desktop_centered,
				enabled: desktop_disabled,
				autoHeight: slider_auto_height_desktop,
				direction: slider_direction,
			},
			1080: {
				centeredSlides: desktop_centered,
				initialSlide: initialSlideDesktop,
				slidesPerView: perViewDesktop,
				spaceBetween: betweenDesktop,
				enabled: desktop_disabled,
				autoHeight: slider_auto_height_desktop,
				direction: slider_direction,
			},
		},
		thumbs: {
			swiper: thumbs_of_swiper,
		},
		navigation: navigationSubSettings,
		on: {
			init: function () {
				const prevButton = document.querySelector(`${swiper_selector}`).parentElement.querySelector('.swiper-button-prev');
				if (prevButton) {
					prevButton.classList.add('swiper-button-disabled');
				}
			},
			slideChange: function () {
				const prevButton = document.querySelector(`${swiper_selector}`).parentElement.querySelector('.swiper-button-prev');
				const nextButton = document.querySelector(`${swiper_selector}`).parentElement.querySelector('.swiper-button-next');

				if (prevButton) {
					if (this.isBeginning) {
						prevButton.classList.add('swiper-button-disabled');
					} else {
						prevButton.classList.remove('swiper-button-disabled');
					}
				}

				if (nextButton) {
					if (this.isEnd) {
						nextButton.classList.add('swiper-button-disabled');
					} else {
						nextButton.classList.remove('swiper-button-disabled');
					}
				}

				if (this.pagination && this.pagination.bullets) {
					this.pagination.render();
					this.pagination.update();
				}
			},
		},
	});

	swiper_f.init();
  if(document.querySelector(".swiper-button-next")) {
    document.querySelectorAll(".swiper-button-next").forEach(function(element) {
      var section = element.dataset.forSection;
      element.addEventListener("click",  function () {
        if (section && swiper_selector == "#" + section) {
          swiper_f.slideNext();
        }
      });
    });
  }

  if (document.querySelector(".swiper-button-prev")) {
    document.querySelectorAll(".swiper-button-prev").forEach(function(element) {
      var section = element.dataset.forSection;
      element.addEventListener("click",  function () {
        if (section && swiper_selector == "#" + section) {
          swiper_f.slidePrev();
        }
      });
    });
  }

	return swiper_f;
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll(`.${customSwiper.classes.swiper}`).forEach(function(element) {
  	var curr_id = element.getAttribute("id") ? element.getAttribute("id")  : '';
  	if(curr_id.length < 1){
    	curr_id = 'location_image_slider_' + element.parent().find('.location_slide_id').text();
        element.setAttribute('id',curr_id);
    }
    initNewSwiper("#" + curr_id);
  });
}, false);